<div class="review-content">
    <app-review-list></app-review-list>
</div>
